import { render, staticRenderFns } from "./BufferItemList.vue?vue&type=template&id=747a537b&scoped=true&"
import script from "./BufferItemList.vue?vue&type=script&lang=js&"
export * from "./BufferItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747a537b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('747a537b', component.options)
    } else {
      api.reload('747a537b', component.options)
    }
    module.hot.accept("./BufferItemList.vue?vue&type=template&id=747a537b&scoped=true&", function () {
      api.rerender('747a537b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/contentbuffers/BufferItemList.vue"
export default component.exports